import { type ButtonProps } from '@naf-simba/elements-buttons';
import { ColorVariant } from '../../../../types/featuredBenefitBlockType';

export type LegacyButtonVariant =
  | 'signature'
  | 'outline'
  | 'spruce'
  | 'secondary'
  | 'spruce-secondary'
  | 'outline-inverted'
  | 'danger'
  | 'critical'
  | 'information';

const variantsMap = new Map<LegacyButtonVariant, Pick<ButtonProps, 'variant' | 'color' | 'shade'>>([
  ['signature', { color: 'primary', variant: 'contained' }],
  ['secondary', { color: 'secondary', variant: 'contained', shade: 'light' }],
  ['spruce', { color: 'secondary', variant: 'contained' }],
  ['spruce-secondary', { color: 'secondary', variant: 'contained', shade: 'light' }],
  ['danger', { color: 'critical', variant: 'contained' }],
  ['critical', { color: 'critical', variant: 'contained' }],
  ['information', { color: 'information', variant: 'contained' }],
  ['outline', { color: 'primary', variant: 'outlined' }],
  ['outline-inverted', { color: 'alternative', variant: 'outlined' }],
]);

export const mapSimbaVariant = (
  variant: LegacyButtonVariant | ColorVariant = 'signature',
): Pick<ButtonProps, 'variant' | 'color' | 'shade'> =>
  variantsMap.get(variant as LegacyButtonVariant) ?? variantsMap.get('signature')!;
